function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.333A6.67 6.67 0 001.333 8 6.669 6.669 0 008 14.667 6.67 6.67 0 0014.667 8 6.67 6.67 0 008 1.333z",
  fill: "#FFE58A"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.667 11.333L3.333 8l.94-.94 2.394 2.387 5.06-5.06.94.946-6 6z",
  fill: "#005646"
});

function SvgYellowCheckCircleDarkMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgYellowCheckCircleDarkMode;